import { AddOnItemName } from "./dashboard";

export enum Plans {
  FREE = "free",
  STARTER = "starter",
  PRO = "pro",
  VA = "va",
  PRO_YEARLY = "pro_yearly",
  STARTER_YEARLY = "starter_yearly",
  VA_YEARLY = "va_yearly",
}

export enum OverridePlanName {
  PRO = "pro",
  STARTER = "starter",
  VA = "va",
}

export const getEquivalentPlansFromOverride = (
  overridePlanName: OverridePlanName,
) => {
  const plans: { [key: string]: Plans[] } = {
    [OverridePlanName.PRO]: [Plans.PRO, Plans.PRO_YEARLY],
    [OverridePlanName.STARTER]: [Plans.STARTER, Plans.STARTER_YEARLY],
    [OverridePlanName.VA]: [Plans.VA, Plans.VA_YEARLY],
  };
  return overridePlanName in plans ? plans[overridePlanName] : [];
};

export const DisplayName: { [key: string]: string } = {
  [Plans.FREE]: "Free",
  [Plans.STARTER]: "Starter",
  [Plans.PRO]: "Pro",
  [Plans.VA]: "AI Virtual Assistant",
  [Plans.PRO_YEARLY]: "Pro",
  [Plans.STARTER_YEARLY]: "Starter",
  [Plans.VA_YEARLY]: "AI Virtual Assistant",
  [AddOnItemName.partnership_data]: "Partnership Data",
  [AddOnItemName.custom_email]: "Your Professional Email Setup",
  [AddOnItemName.support_call]: "1:1 Onboarding Call",
};
